"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../../Theme"));

var _TextField = _interopRequireDefault(require("../../TextField"));

var _constant = require("../constant");

var _SearchInput = _interopRequireDefault(require("./SearchInput.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SearchButton = _styledComponents.default.button.withConfig({
  displayName: "SearchInput__SearchButton",
  componentId: "sc-ydo49v-0"
})(["position:absolute;font-size:", ";top:14px;right:14px;background:", ";border:0;padding:0;cursor:pointer;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.fontSize.normal;
}, function (_ref2) {
  var theme = _ref2.theme,
      disabled = _ref2.disabled;
  return disabled ? 'transparent' : theme.colors.default;
}, function (_ref3) {
  var theme = _ref3.theme,
      disabled = _ref3.disabled;
  return disabled ? theme.colors.greyMedium : theme.colors.secondary;
});

var SearchWrapper = _styledComponents.default.div.withConfig({
  displayName: "SearchInput__SearchWrapper",
  componentId: "sc-ydo49v-1"
})(["position:relative;margin-top:", ";"], function (_ref4) {
  var theme = _ref4.theme,
      newVersion = _ref4.newVersion;
  return !newVersion ? theme.space.standard : theme.space.tiny;
});

var SearchInput = function SearchInput(_ref5) {
  var onClickSearch = _ref5.onClickSearch,
      placeholder = _ref5.placeholder,
      translation = _ref5.translation,
      errorMsgProp = _ref5.errorMessage,
      initialValue = _ref5.initialValue,
      accessible = _ref5.accessible,
      theme = _ref5.theme,
      newVersion = _ref5.newVersion,
      disabled = _ref5.disabled,
      onChangeEmail = _ref5.onChangeEmail;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var _useState = (0, _react.useState)(initialValue),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      focused = _useState4[0],
      setFocused = _useState4[1];

  var _useState5 = (0, _react.useState)(errorMsgProp),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      errorMessage = _useState6[0],
      setErrorMessage = _useState6[1];

  var _useState7 = (0, _react.useState)(!!errorMessage),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      showError = _useState8[0],
      setShowError = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      isInvalidEmail = _useState10[0],
      setIsInvalidEmail = _useState10[1];

  var tabIndex = !accessible ? '-1' : '0';
  var search = translation.search,
      invalidEmailMessage = translation.invalidEmailMessage,
      detailedInvalidEmailMessage = translation.detailedInvalidEmailMessage,
      noData = translation.noData;

  var validateEmailString = function validateEmailString(str) {
    var isValidEmail = _constant.EMAIL_REGEX.test(String(str).toLowerCase());

    if (!!str && !isValidEmail) {
      setErrorMessage(newVersion ? detailedInvalidEmailMessage : invalidEmailMessage);
      setShowError(true);
      setIsInvalidEmail(true);
    } else {
      setShowError(false);
      setIsInvalidEmail(false);
    }
  };

  (0, _react.useEffect)(function () {
    if (errorMessage === noData) {
      setErrorMessage(errorMessage);
    } else if (initialValue && !errorMessage) {
      validateEmailString(initialValue);
    } // eslint-disable-next-line

  }, [errorMessage, initialValue]);

  var onFocusedHandler = function onFocusedHandler() {
    setFocused(true);

    if (!isInvalidEmail) {
      setShowError(false);
    }
  };

  var onBlurHandler = function onBlurHandler(e) {
    var newValue = e.target.value;
    setFocused(false);
    validateEmailString(newValue);
    setValue(newValue);
    onChangeEmail(newValue);
  };

  var onChangeHandler = function onChangeHandler(event) {
    var newValue = event.target.value;

    if (isInvalidEmail) {
      validateEmailString(newValue);
    }
  };

  var inputProps = {
    validateMessage: errorMessage,
    // eslint-disable-next-line no-nested-ternary
    validateStatus: showError && !newVersion ? 'error' : showError && newVersion ? 'warning' : null,
    label: placeholder,
    accessible: accessible,
    placeholder: focused ? '' : placeholder,
    onFocus: onFocusedHandler,
    onBlur: onBlurHandler,
    value: value,
    onChange: onChangeHandler,
    disabled: newVersion ? disabled : false
  };

  var handleSearch = function handleSearch() {
    if (!showError) {
      onClickSearch(value);
    }
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(SearchWrapper, {
      newVersion: newVersion
    }, /*#__PURE__*/_react.default.createElement(_TextField.default, (0, _extends2.default)({
      showIcon: false
    }, inputProps)), /*#__PURE__*/_react.default.createElement(SearchButton, {
      tabIndex: tabIndex,
      onClick: handleSearch,
      disabled: disabled
    }, search));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

SearchInput.propTypes = _SearchInput.default.PropTypes;
SearchInput.defaultProps = _SearchInput.default.DefaultProps;
var _default = SearchInput;
exports.default = _default;